import * as React from "react";

import { Code, Stack, Text } from "@mantine/core";
import { Link } from "react-router-dom";

import { WhatsNewUpdate } from "../update";

export const update20240506: WhatsNewUpdate = {
  id: "5666AEB1-6F45-49A8-924B-840B93F2ABF1",
  date: "2024-05-06",
  subject: "FlyByWire A32NX Templates",
  content: (
    <Stack>
      <Text>
        Just a quick update to let you know that fs-checklist-studio now has templates for the
        excellent{" "}
        <a href="https://flybywiresim.com/a32nx/" target="_blank">
          FlyByWire A320neo (A32NX)
        </a>
        . You can choose between the{" "}
        <Link to="/templates/aircraft/fbw-a32nx">standard checklist</Link> or the{" "}
        <Link to="/templates/aircraft/fbw-a32nx-expanded">expanded normal procedures</Link> (with
        more than 400 checklist items!) depending on the level of detail you'd like.
      </Text>
      <Text>
        I'm hoping to continue slowly adding aircraft over the summer. If there are more aircraft
        templates you'd like to see in the future, I'd love to hear from you! Drop me a line at{" "}
        <Code>hi</Code> at (this web address).
      </Text>
      <Text>
        Keep checklisting,
        <br />
        -Fred
      </Text>
    </Stack>
  ),
};
